// Base
import Head from 'next/head'

// Sections
import LocationWrapper from '@sections/location/LocationWrapper'

export default function Location() {
  return (
    <>
      <Head>
        <title>RatePunk Premium | Location</title>
        <meta name="description" content="RatePunk Premium" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <main>
        <LocationWrapper />
      </main>
    </>
  )
}
